module.exports = __webpack_public_path__ + "static/media/comparison-icon.2f770baa.svg";